import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../store/store";

interface NavigationsState {
  page: string;
  history: string[];
}

const initialState: NavigationsState = {
  page: "",
  history: [],
};

const navigationsSlice = createSlice({
  name: "navigation",
  initialState: initialState,
  reducers: {
    navigate: (state, action: PayloadAction<string>) => {
      state.page = action.payload;
      if (state.history[state.history.length] != action.payload) state.history = [...state.history, action.payload];
    },
    navigateBack: (state, action: PayloadAction<string>) => {
      state.page = action.payload;
      state.history = state.history.splice(0, state.history.length - 1);
    },
  },
  extraReducers: undefined,
});

export const pageNavigation = (state: RootState) => state.navigation.page;
export const historyNavigation = (state: RootState) => state.navigation.history;
export const { navigate, navigateBack } = navigationsSlice.actions;
export default navigationsSlice.reducer;
